// Off-screen feed cards get a class that pauses their CSS animations
// (custom.css: .feed-card-offscreen …). The class is toggled straight on the
// DOM node from an IntersectionObserver callback — no component state, no
// re-render — so a long feed of animated cards costs nothing while scrolled
// past.
export const OFFSCREEN_CLASS = 'feed-card-offscreen';
export const CARD_OBSERVER_OPTIONS = { threshold: 0, rootMargin: '150px 0px' };

export function applyCardVisibility(element, isIntersecting) {
    if (!element || !element.classList) {
        return;
    }
    element.classList.toggle(OFFSCREEN_CLASS, !isIntersecting);
}
